import React from 'react'

import { ReactComponent as HallIcon } from './icons/mobile-hall-icon.svg'
import { ReactComponent as ProgrammeIcon } from './icons/mobile-programme-icon.svg'
import { ReactComponent as GameIcon } from './icons/mobile-game-icon.svg'
import { ReactComponent as NetworkingIcon } from './icons/mobile-networking-icon.svg'
import { ReactComponent as HelpdeskIcon } from './icons/mobile-helpdesk-icon.svg'
import { ReactComponent as Gallery } from './icons/mobile-gallery-icon.svg'

type SvgIcon = 'hall' | 'programme' | 'game' | 'networking' | 'helpdesk' | 'gallery'

type SvgIconProps = {
  icon: SvgIcon
  stroke?: string
  fill?: string
}

export default function Svg({ icon, stroke, fill }: SvgIconProps) {
  switch (icon) {
    case 'hall':
      return <HallIcon />
    case 'programme':
      return <ProgrammeIcon />
    case 'game':
      return <GameIcon />
    case 'networking':
      return <NetworkingIcon />
    case 'helpdesk':
      return <HelpdeskIcon />
    case 'gallery':
      return <Gallery />
    default:
      return null
  }
}
